export default __webpack_public_path__ + "static/media/FNMEKA_LOGO_2.697df671.png";